import { Box } from '@mui/material';
import { FC } from 'react';

type Props = {
  icon: JSX.Element;
};

export const IconArea: FC<Props> = ({ icon }) => {
  return (
    <Box
      sx={{
        marginRight: '12px',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {icon}
    </Box>
  );
};
